const COMMON_ACTIONS = ["list", "show"];
const ALL_ACTIONS = [
  "list",
  "show",
  "create",
  "edit",
  "delete",
  "scale",
  "updateVersion",
  "retry",
  "menuState",
  "menuAction",
  "menuLaunch",
  "access",
  "tenantMenuAction"
];

const SAAS_ADMIN_RESOURCES = {
  eks: [],
  pools: ["retry", "create","access"],
  nodegroups: ["retry", "create"],
  instances: [
    "scale",
    "updateVersion",
    "edit",
    "create",
    "retry",
    "menuState",
    "menuAction",
    "menuLaunch",
    "access"
  ],
  tenants: [],
  users: [],
  dev: [],
  addons: [
    "edit","delete", "create"
  ],
  subscription: [],
  cost:[],
  settings: [],
  profileSettings: [],
  versionSettings: [],
  addonSettings: []
};
const TENANT_ADMIN_RESOURCES = {
  instances: [
    "menuAction",
    "tenantMenuAction"
  ],
  subscription: [],
  users: ['create',  
    "edit",
    "delete"]
};
const TENANT_USER_RESOURCES = {
  instances: ['list', 'show']
};


export const can = async (authProvider, { resource, action, params }) => {
  if (resource === "home" && action === "list") {
    return {
      can: true,
    };
  }
  const user = await authProvider.getIdentity();
  const isSaasAdmin = user.isAdminNest || (user.tenant == "__root__");
  const isTenantAdmin = user.isTenantAdmin;
  /**
   * SaaS Admin:
   * If not specified actions in SAAS_ADMIN_RESOURCES, then allow all actions
   */
  if (
    isSaasAdmin &&
    (SAAS_ADMIN_RESOURCES[resource] &&
      (SAAS_ADMIN_RESOURCES[resource].length === 0 ||
        SAAS_ADMIN_RESOURCES[resource].includes(action) ||
        COMMON_ACTIONS.includes(action) ||
        !ALL_ACTIONS.includes(action)))
  ) {
    return {
      can: true,
    };
  }

  if (
    !isSaasAdmin &&
    isTenantAdmin &&
    TENANT_ADMIN_RESOURCES[resource] &&
    (TENANT_ADMIN_RESOURCES[resource].includes(action) ||
      COMMON_ACTIONS.includes(action) ||
      !ALL_ACTIONS.includes(action))
  ) {
    return {
      can: true,
    };
  }

  if (
    !isSaasAdmin &&
    !isTenantAdmin &&
    TENANT_USER_RESOURCES[resource] &&
    (TENANT_USER_RESOURCES[resource].includes(action) ||
      COMMON_ACTIONS.includes(action) ||
      !ALL_ACTIONS.includes(action))
  ) {
    return {
      can: true,
    };
  }
  console.warn("Fail to check role:", resource, action, false);
  return {
    can: false,
  };
};
